import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './general.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getSelectedProductLine = createSelector(selectProjectState, (state: State) => state.selectedProductLine);

export const getPartnerSearch = createSelector(selectProjectState, (state: State) => state.partnerSearchObject);
export const getProgressId = createSelector(selectProjectState, (state: State) => state.progressId);
export const getFullOperationId = createSelector(selectProjectState, (state: State) => state.fullOperationId);
export const getQuotingId = createSelector(selectProjectState, (state: State) => state.quotingId);
export const getProductLines = createSelector(selectProjectState, (state: State) => state.productLines);
export const getPrevUrl = createSelector(selectProjectState, (state: State) => state.prevUrl);
